import {
  TrackerInstance,
  TrackerEvent,
  TrackerConfig
} from './tracker-factory';

const DEFAULT_ATTEMPTS = 5;
const defaultConfig = {
  retryLimit: DEFAULT_ATTEMPTS
};

class BeaconAdapter implements TrackerInstance {
  private MAX_ATTEMPTS: number;
  private config?: TrackerConfig;

  constructor(config: TrackerConfig = {}) {
    this.config = { ...defaultConfig, ...config };
    this.MAX_ATTEMPTS = this.config.retryLimit || DEFAULT_ATTEMPTS;
  }

  public report(event: TrackerEvent) {
    this.attemptReport(event, 0);
  }

  private attemptReport(event: TrackerEvent, attempt: number) {
    try {
      window.lucid.beacon.recordEvent(event);
    } catch (error) {
      if (attempt < this.MAX_ATTEMPTS) {
        attempt++;
        setTimeout(() => this.attemptReport(event, attempt), 200);
      } else {
        // eslint-disable-next-line no-console
        console.error(`Beacon event unable to fire: ${event.name}.`, error);
      }
    }
  }
}

export default BeaconAdapter;
